import React, { ReactNode } from 'react';
import styled from 'styled-components';

import mq from '../../../styles/breakpoints';
import Spacings from '../../../styles/Spacings';

import { Widths } from '../../../tokens';

interface Props {
  children: ReactNode;
  className?: string;
  id?: string;
}

const ContentWrapper = ({ children, className, id }: Props) => (
  <Container id={id} className={className}>
    {children}
  </Container>
);

const Container = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  max-width: ${Widths.PAGE_MAX};
  padding-left: ${Spacings.S};
  padding-right: ${Spacings.S};
  position: relative;

  ${mq.from.breakpoint.M`
    padding-left: ${Spacings.M};
    padding-right: ${Spacings.M};
  `}
`;
export default ContentWrapper;
